// @ts-expect-error no-type
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CollaborationSidebarWithWrapper({
  children
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: "layout-and-collaboration-sidebar",
    children: [children, /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        CollaborationSidebarContainer
      }) => /*#__PURE__*/_jsx(CollaborationSidebarContainer, {})
    })]
  });
}